<template>
  <div class="container is-fluid is-no-padding">
    <div class="">
      <router-view />
    </div>
  </div>
</template>

<script>
  import { bodyClassMixin } from '@/mixins/bodyClass'
  // import MenuBar from "@/views/_globals/MenuBar.vue"

  export default {
    // components: {
    //   MenuBar,
    // },
    data: function() {
      return {
        selectedTags: [],
      }
    },
    mixins: [ bodyClassMixin('default') ]
  }
</script>

<style lang="scss">
  @import '@/assets/scss/global';
  @import '@/assets/scss/default';
</style>
